import "./base.js";
import "./booking.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Models ??= {};

AppointmentBooking.Wizard.Models.Wizard = class Wizard extends AppointmentBooking.Wizard.Models.Base {
  constructor() {
    super(...arguments);
    this.currentStep = this.currentStep.bind(this);
    this.isAtStart = this.isAtStart.bind(this);
    this.isAtEnd = this.isAtEnd.bind(this);
  }

  defaults() {
    return {
      steps: [], // The steps this wizard will execute
      currentStepIndex: 0,
      currentStepProgress: 0,
      mainMenuExpanded: false,
    };
  }

  currentStep() {
    return this.get("steps")[this.get("currentStepIndex")];
  }

  isAtStart() {
    return this.get("currentStepIndex") === 0;
  }

  isAtEnd() {
    return this.get("currentStepIndex") === this.get("steps").length - 1;
  }
};

AppointmentBooking.Wizard.Models.Wizard.prototype.relations = [
  {
    type: Backbone.HasOne,
    key: "booking",
    relatedModel: "AppointmentBooking.Wizard.Models.Booking",
  },
];

AppointmentBooking.Wizard.Models.Wizard.initializeRelations();
